import type { CartResponse } from '@backmarket/http-api/src/api-specs-checkout/cart/cart.types'

export function isCountryShippable(
  country: string | null | undefined,
  shippableCountries: CartResponse['shippableCountries'],
) {
  // When the customer has no pre-defined address (i.e.: new user)
  if (!country) {
    return true
  }

  return shippableCountries.some(({ countryCode }) => countryCode === country)
}
